import React, { useEffect, useState } from "react";
import { Activity } from "../types/types";
import { Avatar, Backdrop, Card, CardActionArea, CardContent, CardHeader, CircularProgress, Container, Fab, Grid, Typography } from "@mui/material";
import { useAuthContext } from "../contexts/AuthContext";
import { grey, } from "@mui/material/colors";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getApiUrlFromStorage, getFormattedDateTime, getTimeSpent, getTodayDateEnd, getTodayDateStart, getTokenFromStorage } from "../helpers/helpers";
import ActivityHeader from "./ActivityHeader";

const ActivityList = () => {

  const [activities, setActivities] = useState<Activity[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const apiUrl = getApiUrlFromStorage();
  const token = getTokenFromStorage();




  useEffect(() => {
    setIsLoading(true);

    const todayDateStart = getTodayDateStart();
    const todayDateEnd = getTodayDateEnd();

    if (apiUrl && token) {
      fetch(`${apiUrl}/activities?populate=activity_type&sort=updatedAt:desc&filters[createdAt][$gte]=${todayDateStart}&filters[createdAt][$lte]=${todayDateEnd}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(res => {
          if (!res.ok) {
            throw Error('Could not fetch activities');
          }
          return res.json();
        })
        .then((data) => {
          setActivities(data.data);
        })
        .catch((err) => {
          // catches network errors + http not OK errors
          console.log("Unable to fetch data");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [apiUrl, token]);



  const fabStyle = {
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed',
  };

  const handleEditActivity = (e: React.MouseEvent, id: number) => {
    e.preventDefault();
    navigate(`/activity-details-edit/${id}`);
  }

  const handleAddActivity = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/activity-details-add');
  }

  return (
    <>
      <ActivityHeader user={user} />
      {
        <div>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      }
      <Container>
        <Grid container spacing={2}>
          {
            activities.map((activity) => {
              return (
                <Grid item lg={3} md={4} sm={6} xs={12} key={activity.id}>
                  <Card onClick={(e) => handleEditActivity(e, activity.id)}>
                    <CardActionArea>
                      <CardHeader
                        sx={{ backgroundColor: grey[300] }}
                        avatar={
                          <Avatar sx={{ bgcolor: activity.attributes.activity_type.data.attributes.color }} >
                            {activity.attributes.activity_type.data.attributes.name.charAt(0).toUpperCase()}
                          </Avatar>
                        }
                        title={activity.attributes.activity_type.data.attributes.name.toUpperCase()}
                      />
                      <CardContent >
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          Start time: {getFormattedDateTime(activity.attributes.start_time)}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          End time: &nbsp;{getFormattedDateTime(activity.attributes.end_time)}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          Time spent: &nbsp;{getTimeSpent(activity.attributes.start_time, activity.attributes.end_time)}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              )
            })
          }
        </Grid>
      </Container>
      <Fab color="primary" aria-label="add" sx={fabStyle} onClick={handleAddActivity}>
        <Add />
      </Fab>
    </>);
}

export default ActivityList;